import {
  createStore,
  createEffect,
} from "effector";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { getUuidAndSession } from "../../../common/localStorage";

export interface IDemGroup {
  forAll: number;
  houseId: number | null;
  icon: string;
  id: number;
  isPayable: number;
  name: string;
  normative: number;
  priorityId: number;
}

export interface IQueryDemGroup {
  companyId: number;
  accountId: number;
}

export interface IQueryDemGroupsResult {
  loaded: boolean;
  fail: boolean;
  failMsg: string;
  groups: IDemGroup[];
}

export const $demandGroups = createStore<IQueryDemGroupsResult>({
  loaded: false,
  fail: false,
  failMsg: "",
  groups: [],
});

export const queryDemGroups = createEffect<IQueryDemGroup, any>();

$demandGroups.on(queryDemGroups.doneData, (_, val) => val);

queryDemGroups.use(({ accountId, companyId }) =>
  fetch("https://izba.kras-abs.ru/api/v3/demand/demandGroups", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      companyId: companyId,
      accountId: accountId == -1 ? "" : accountId,
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (
        !("orderGroups" in res)
      ) {
        let msg = JSON.stringify(res);
        if ("message" in res) msg = res.message;
        return getQueryNewsResObj(msg);
      }
      let groups = res.orderGroups as IDemGroup[];
      return getQueryNewsResObj("", false, groups);
    })
    .catch((err) => {
      return getQueryNewsResObj(err.message);
    })
);

function getQueryNewsResObj(
  failMsg: string = "",
  fail: boolean = true,
  groups: IDemGroup[] = [] as IDemGroup[]
): IQueryDemGroupsResult {
  return {
    loaded: true,
    fail: fail,
    failMsg: failMsg,
    groups: groups,
  } as IQueryDemGroupsResult;
}
